<template>
    <Identity />
</template>

<script setup>
    import Identity from '@/components/shared/Identity.vue'
    import { statusBar } from '@/services'

    onMounted(() => {
        statusBar.setTheme()
    })

    onActivated(() => {
        statusBar.setTheme()
    })
</script>
